export const SEARCHED = "SEARCHED";
export const SEARCH_REQUEST = "SEARCH_REQUEST";
export const SEARCH_SUCESS = "SEARCH_SUCESS";
